<template lang="pug">
  .by-package-type
    GenericTable(ref="grid" :loading="loading")
      tr(slot="thead")
        th Id
        th Name
        th Type
        th Count
      tr.clickable(v-for="p in packages" @click="getPackageDetails(p.id)")
        td {{p.id}}
        td {{p.name}}
        td {{p.type}}
        td {{p.count}}

    PackageTypeDetailsModal(ref="packageTypeDetailsModal")
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import TrackNTrace from '@/service/apis/TrackNTrace'
import PackageTypeDetailsModal from './PackageTypeDetailsModal'

export default {
  data() {
    return {
      loading: false,
      packages: null
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      TrackNTrace.getLocationPackages(this.$route.params.id)
        .then((resp) => {
          this.packages = resp.data.packageCounts.packageCount
          this.loading = false
        })
        .catch((e) => { this.$emit('error', e) })
    },
    getPackageDetails(id) {
      TrackNTrace.getLocationPackageDetails(this.$route.params.id, id)
        .then((resp) => {
          this.$refs.packageTypeDetailsModal.open(resp.data.packages)
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  components: {
    GenericTable,
    PackageTypeDetailsModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/ByPackageType.vue